import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_VP } from '$Deposits/store/actions/DepositPost'
import { VP_Submit } from '$Deposits/store/actions/DepositEvent'



class VP extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {
            SetDepositPayments_VP,
            DepositNextStep,
            DepositSuccessPage,
            AvailableMethods,
            MoneyInput,
            SubmitBtn,
            NextStep,
            SuccessPage,
            TipsView,
        } = this.props

        return (
            <>
                {
                    !DepositNextStep && !DepositSuccessPage &&
                    <>
                        <TipsView msg={`Vui lòng quét mã QR bằng ứng dụng Viettel Pay và điền nội dung hiển thị tại bước 2 để lệnh gửi tiền được cập nhật nhanh chóng`} />
                        <AvailableMethods />
                        <MoneyInput />
                        <SubmitBtn
                            submitBtn={VP_Submit}
                            onPress={() => { SetDepositPayments_VP() }}
                            submitBtnItem={'Chuyển'}
                        />
                    </>
                }
                {
                    DepositNextStep &&
                    <NextStep />
                }
                {
                    DepositSuccessPage &&
                    <SuccessPage />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
});
const mapDispatchToProps = {
    SetDepositPayments_VP: (data = {}) => SetDepositPayments_VP(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(VP);


